import { CoursizModel } from './coursiz';
import { ProductEdited } from '../models';

export class CoursizEdited implements ProductEdited<CoursizModel> {
  slug: string;
  name: string;
  data: CoursizModel;
  updatedAt?: Date;
  documents?: string[];
  visible?: boolean;
  active?: boolean;
  publishedAt?: Date;
  folderProduct?: { slug: string };
  hasConfigDraft?: boolean;

  constructor(edited?: CoursizEdited) {
    this.slug = edited?.slug;
    this.name = edited?.name;
    this.data = new CoursizModel(edited?.data);
    this.updatedAt = edited?.updatedAt ? new Date(edited.updatedAt) : null;
    this.publishedAt = edited?.publishedAt ? new Date(edited.publishedAt) : null;
    this.documents = edited?.documents ?? [];
    this.folderProduct = edited?.folderProduct;
    this.hasConfigDraft = edited?.hasConfigDraft ?? false;
  }
}
export enum CoursizStrategy {
  DEFAULT = 'default',
  POSITIVE = 'positive',
}
